import { createTheme } from '@mui/material/styles';

const brandKit = {
  nameTreatment: {
    full: 'Personal Finance Toolkit',
    short: 'Personal Finance',
    wordmark: 'PERSONAL FINANCE TOOLKIT',
    tagline: 'Plan clearly. Save confidently.'
  },
  logoUsage: {
    minClearSpace: 12,
    minWidth: 120,
    preferredLockup: 'icon-left-wordmark',
    donts: ['Do not stretch', 'Do not rotate', 'Do not use low-contrast backgrounds']
  },
  colorPalette: {
    midnight: '#1E2536',
    ocean: '#2D4F8C',
    sky: '#4DA1FF',
    mint: '#63D2B3',
    coral: '#FF8A65',
    cloud: '#F4F7FB'
  },
  typographyScale: {
    display: 56,
    h1: 44,
    h2: 36,
    h3: 30,
    h4: 24,
    h5: 20,
    body: 16,
    caption: 14
  },
  spacing: {
    unit: 8,
    section: 10,
    card: 3
  },
  iconStyle: {
    family: 'Material Symbols Rounded',
    stroke: 1.75,
    cornerRadius: 10
  }
};

const theme = createTheme({
  spacing: brandKit.spacing.unit,
  brandKit,
  palette: {
    primary: {
      light: brandKit.colorPalette.sky,
      main: brandKit.colorPalette.ocean,
      dark: brandKit.colorPalette.midnight
    },
    secondary: {
      light: '#FFFFFF',
      main: brandKit.colorPalette.coral,
      dark: '#E66F47'
    },
    success: {
      main: brandKit.colorPalette.mint
    },
    warning: {
      main: '#FFD6C9'
    },
    background: {
      default: '#FFFFFF',
      paper: brandKit.colorPalette.cloud
    }
  },
  typography: {
    fontFamily: "'Inter', 'Work Sans', sans-serif",
    fontSize: 16,
    h1: {
      fontFamily: "'Space Grotesk', 'Roboto Condensed', sans-serif",
      fontSize: brandKit.typographyScale.h1,
      fontWeight: 700,
      letterSpacing: -0.5
    },
    h2: {
      fontFamily: "'Space Grotesk', 'Roboto Condensed', sans-serif",
      fontSize: brandKit.typographyScale.h2,
      fontWeight: 700,
      letterSpacing: -0.3
    },
    h3: {
      fontSize: brandKit.typographyScale.h3,
      fontWeight: 700
    },
    h4: {
      fontSize: brandKit.typographyScale.h4,
      fontWeight: 700
    },
    h5: {
      fontSize: brandKit.typographyScale.h5,
      fontWeight: 600
    },
    subtitle1: {
      fontSize: 18,
      lineHeight: 1.6,
      color: '#43506A'
    },
    body1: {
      fontSize: brandKit.typographyScale.body,
      lineHeight: 1.7
    },
    body2: {
      fontSize: brandKit.typographyScale.caption,
      lineHeight: 1.5
    },
    button: {
      fontWeight: 600,
      textTransform: 'none'
    }
  },
  shape: {
    borderRadius: 12
  }
});

export default theme;
